module.exports = __webpack_public_path__ + "static/gallery-6-fad77e7ededba05c1d5a1659b464bfae.jpg";